/**
 * Reports workspace navigation (Order 31H).
 */
import type { LucideIcon } from "lucide-react";
import {
  ArrowDownLeft,
  ArrowUpRight,
  FileUp,
  LayoutGrid,
  Megaphone,
  ScrollText,
} from "lucide-react";

export type ReportsNavId =
  | "overview"
  | "campaigns"
  | "outgoing"
  | "incoming"
  | "message-log"
  | "contact-imports";

export type ReportsNavItem = {
  readonly id: ReportsNavId;
  readonly to: string;
  readonly labelKey: string;
  readonly shortLabelKey: string;
  readonly descriptionKey: string;
  readonly icon: LucideIcon;
  readonly testId: string;
  /** End match for overview only. */
  readonly end?: boolean;
};

export const REPORTS_NAV_ITEMS: readonly ReportsNavItem[] = [
  {
    id: "overview",
    to: "/reports",
    labelKey: "reports.nav.overview",
    shortLabelKey: "reports.nav.overviewShort",
    descriptionKey: "reports.nav.overviewDescription",
    icon: LayoutGrid,
    testId: "reports-nav-overview",
    end: true,
  },
  {
    id: "campaigns",
    to: "/reports/campaigns",
    labelKey: "reports.nav.campaigns",
    shortLabelKey: "reports.nav.campaignsShort",
    descriptionKey: "reports.nav.campaignsDescription",
    icon: Megaphone,
    testId: "reports-nav-campaigns",
  },
  {
    id: "outgoing",
    to: "/reports/outgoing",
    labelKey: "reports.nav.outgoing",
    shortLabelKey: "reports.nav.outgoingShort",
    descriptionKey: "reports.nav.outgoingDescription",
    icon: ArrowUpRight,
    testId: "reports-nav-outgoing",
  },
  {
    id: "incoming",
    to: "/reports/incoming",
    labelKey: "reports.nav.incoming",
    shortLabelKey: "reports.nav.incomingShort",
    descriptionKey: "reports.nav.incomingDescription",
    icon: ArrowDownLeft,
    testId: "reports-nav-incoming",
  },
  {
    id: "message-log",
    to: "/reports/message-log",
    labelKey: "reports.nav.messageLog",
    shortLabelKey: "reports.nav.messageLogShort",
    descriptionKey: "reports.nav.messageLogDescription",
    icon: ScrollText,
    testId: "reports-nav-message-log",
  },
  {
    id: "contact-imports",
    to: "/reports/contact-imports",
    labelKey: "reports.nav.contactImports",
    shortLabelKey: "reports.nav.contactImportsShort",
    descriptionKey: "reports.nav.contactImportsDescription",
    icon: FileUp,
    testId: "reports-nav-contact-imports",
  },
];

export const REPORTS_SIDEBAR_WIDTH_EXPANDED = "w-[13.5rem]";
export const REPORTS_SIDEBAR_WIDTH_COLLAPSED = "w-[3.25rem]";
export const REPORTS_SIDEBAR_WIDTH_EXPANDED_PX = 216;
export const REPORTS_SIDEBAR_WIDTH_COLLAPSED_PX = 52;
